import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import { Box, Stack, Switch, Typography } from "@mui/material";

interface Props {
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}

const FollowGroupSharingSwitch = ({ checked, disabled, onChange }: Props) => (
  <Stack
    direction="row"
    sx={[
      { alignItems: "center", gap: 1.5 },
      (theme) => ({ p: 1, borderRadius: 1, border: `1px solid ${theme.palette.divider}` }),
    ]}
  >
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 36,
        height: 36,
        borderRadius: 1,
        bgcolor: theme.palette.action.hover,
      })}
    >
      <FolderOutlinedIcon color="secondary" fontSize="small" />
    </Box>
    <Typography variant="subtitle2">Follow group sharing</Typography>
    <Box sx={{ flexGrow: 1 }} />
    <Switch checked={checked} disabled={disabled} onChange={(_, value) => onChange(value)} />
  </Stack>
);

export default FollowGroupSharingSwitch;
